export enum DateTime {
  HH_MM_SS = 'HH:mm:ss',
  DD_MM_YYYY = 'DD/MM/YYYY',
  TWELE_HOURS = 'hh:mm A',
}

export const WEEK_DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
